/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { FC, useEffect, useState } from 'react';
import { Box, Divider, Grid, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';

import { RootState } from 'src/store';
import { TEMPLATES_EDITOR } from 'src/constants/templates';

import Contents from '../Contents';
import Buttons from '../Buttons';
import EditBranch from 'src/components/editor/EditBranch';

const useStyles = makeStyles(() => ({
  root: {
    width: '20rem',
    minWidth: '20rem',
    maxWidth: '20rem',
    position: 'relative'
  },
  tabScroll: {
    width: '20rem',
    minWidth: '20rem',
    height: 'calc(100vh - 6.94rem)',

    display: 'flex',
    flexDirection: 'column',
    overflow: 'scroll',
    backgroundColor: '#ffffff',

    scrollbarWidth: 'none',
    scrollbarHeight: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  tabsWrapper: {
    width: '100%',
    minHeight: '3.94rem',

    backgroundColor: '#fff'
  },
  tabs: {
    minHeight: '3.94rem',
    padding: '0 1rem',

    display: 'flex',
    // overflowX: 'scroll',
    gap: '1rem',

    color: '#bebebe',
    fontFamily: 'Archivo',
    fontSize: '0.875rem',

    scrollbarWidth: 'none',
    scrollbarHeight: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },

  actTab: {
    cursor: 'pointer',
    display: 'flex',
    margin: 'auto 0',
    flexDirection: 'column',

    color: '#000',
    fontWeight: 700,
    letterSpacing: '0.02em'
  },
  tab: {
    cursor: 'pointer',
    display: 'flex',
    margin: 'auto 0',
    flexDirection: 'column',

    fontWeight: 700,
    letterSpacing: '0.02em'
  }
}));

const tabs = [
  { value: 'contents', label: 'CONTENTS' },
  { value: 'buttons', label: 'BUTTONS' }
];

const UiNavRight: FC = () => {
  const classes = useStyles();
  const [currentTab, setCurrentTab] = useState<string>('contents');
  let currentBranchIndex = useSelector(
    (state: RootState) => state.imageUpload.currentBranchIndex
  );
  const CURRENT_BRANCH =
    currentBranchIndex === '' ? '' : `_${currentBranchIndex}`;
  const handleTabsChange = (value: string): void => {
    setCurrentTab(value);
  };

  const TEMPLATE_TITLE = window.location.pathname
    .split('/')[2]
    .toUpperCase()
    .split('-')
    .join(' ');

  return (
    <div className={classes.root}>
      <div className={classes.tabsWrapper}>
        <div className={classes.tabs}>
          {tabs.map(tab => (
            <div
              key={tab.value}
              className={
                currentTab === tab.value ? classes.actTab : classes.tab
              }
              onClick={() => handleTabsChange(tab.value)}
            >
              {tab.value.toUpperCase()}
            </div>
          ))}
        </div>
        <Divider />
      </div>
      <Grid className={classes.tabScroll}>
        <Box>
          {TEMPLATES_EDITOR?.[TEMPLATE_TITLE]?.branch && <EditBranch />}
          {/* {!TEMPLATES_EDITOR?.[TEMPLATE_TITLE]?.branch &&
            TEMPLATES_EDITOR?.[TEMPLATE_TITLE]?.['multi' + CURRENT_BRANCH] && (
              <EditMulti />
            )} */}
          {currentTab === 'contents' && (
            <Contents
              datas={
                TEMPLATES_EDITOR?.[TEMPLATE_TITLE]?.[
                  'contents' + CURRENT_BRANCH
                ]
              }
            />
          )}
          {currentTab === 'buttons' && (
            <Buttons
              datas={
                TEMPLATES_EDITOR?.[TEMPLATE_TITLE]?.['buttons' + CURRENT_BRANCH]
              }
            />
          )}
        </Box>
      </Grid>
    </div>
  );
};

export default UiNavRight;
